enum TroubledBorrowerFilterEventsType {
	ALL = "ALL",
	PAST = "PAST",
	PLANNED = "PLANNED"
}

export default TroubledBorrowerFilterEventsType;
